<script lang="ts" setup>
import { ListItemWithCheckProps } from "./ListItemWithCheck.props"

withDefaults(defineProps<ListItemWithCheckProps>(), {
  showCheckmark: false,
  theme: "site",
  infoMessage: null
})
</script>

<template>
  <div class="flex items-center gap-2">
    <IconsCheckmark
      v-if="showCheckmark"
      class="correct-color h-5 w-5"
      :class="theme"
    />
    <span v-else class="h-5 w-5 text-center">•</span>

    <span v-if="infoMessage">
      {{ infoMessage }}
    </span>
  </div>
</template>

<style scoped lang="scss">

.correct-color {
  &.site {
    @apply text-positive-main;
  }
}

.error-color {
  &.site {
    @apply text-negative-main;
  }
}

</style>
